<template>
  <div
    class="counter"
    :class="[
      size,
      {
        stretch,
        ghost,
        'has-slot': $slots.info,
      },
    ]"
  >
    <span
      class="bold counter-text"
      :class="{
        'text-regular': size === 'large',
        'text-small': size !== 'large',
      }"
    >
      {{ value }}
    </span>
    <span
      v-if="$slots.info"
      class="bold counter-info text-small"
    >
      <!-- @slot Texte à droite de la valeur du counter. -->
      <slot name="info" />
    </span>
  </div>
</template>

<script>
import { defineComponent } from "vue";
/**
 * Affiche un compteur d'éléments.
 */
export default defineComponent({
  name: "Counter",
  props: {
    /**
     * Définit la taille du composant.
     */
    size: {
      type: String,
      validator: (value) => ["small", "medium", "large"].includes(value),
      default: "medium",
    },
    /**
     * Somme d'éléments.
     */
    value: {
      type: [Number, String],
      default: 0,
    },
    /**
     * Variante ghost.
     */
    ghost: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stretch() {
      // Si 2 caractères minimum, on adapte la largeur
      return (typeof this.value === "number" && this.value >= 10)
        || (typeof this.value === "string" && this.value.length >= 2)
        || this.$slots.info;
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/infos/counter.scss";
</style>
